export default {
  offlineMode: 'Offline Mode',
};
